import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [
    { id: 1, name: "John Doe", email: "john@example.com" },
    { id: 2, name: "Jane Doe", email: "jane@example.com" },
    { id: 3, name: "Alice Doe", email: "alice@example.com" },
  ],
};

export const UserSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    userdelete: (state, action) => {
    }
  },
});

export default UserSlice.reducer;
export const {userdelete} = UserSlice.actions;